import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Cargo } from 'src/app/core/interfaces/cargo';
import { Utils } from 'src/app/core/resources/utils';
import * as firebase from 'firebase';
import { DatabaseReference } from '@angular/fire/database/interfaces';
import { AuthService } from 'src/app/core/services/authentication.service';
import { FirebaseDatabase } from 'src/app/core/services/firebaseDatabase.service';
import moment from 'moment';
import { StandardMapComponent } from 'src/app/shared/standard-map/standard-map.component';
import { OptionsAutocomplete } from 'src/app/core/interfaces/optionsAutocomplete';
import { Global } from 'src/app/core/resources/global';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { FormMessages } from 'src/app/core/messages/form-messages.enum';
import { DateManager } from 'src/app/core/managers/date.manager';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ModalEnum } from 'src/app/core/enums/modal.enum';
import { DialogComponent } from 'src/app/shared/dialog/dialog.component';
import { StandardMapService } from "src/app/shared/standard-map/standard-map.service";
import { buildMapInfoWindow } from "src/app/core/resources/map-info-window";
import {
  lastTrackingPoint,
  stripVehicleStateObservation,
  trackingPathOnly
} from "src/app/core/resources/tracking-points";
import { CargoLastEvent } from 'src/app/core/interfaces/cargoLastEvent';
import { CargoLastEventService } from 'src/app/core/services/cargo-last-event.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-map-tracking',
  templateUrl: './map-tracking.component.html',
  styleUrls: ['./map-tracking.component.scss'],
  providers: [FirebaseDatabase, CargoLastEventService]
})
export class MapTrackingComponent {

  @Input() public cargos: Cargo[] = [];
  @Input() public cargoSelected: Cargo;
  @Output() loadingMap: EventEmitter<boolean> = new EventEmitter();
  @ViewChild(StandardMapComponent) standardMapComponent: StandardMapComponent;
  cargoSelectedIndex: number;
  public referencesRealtimeCargos: Object = {};
  public cargoAnomaliesList: Object = {};
  public cargoTrackingList: Object = {};
  public lastPoints: Object = {};
  public locationsCargos: Object = {};
  private countCargos = 1;
  private realtimeRequestId = 0;
  private tempLocationsCargos: Object = {};
  private tempLocationsCargo: Object = {};
  mapOptions: OptionsAutocomplete = {
    zoom: 16,
  };
  polyline: Array<Object> = [];
  cargosTemp: Cargo[] = [];
  public loading: boolean = true;
  /**
   * Último evento GPS del servicio seleccionado. Solo se llena cuando hay una placa filtrada:
   * en la vista de todas las placas escuchar `lastEvent` de cada cargo abriría un listener de
   * Firebase por vehículo en ruta.
   */
  private lastGpsEvent: CargoLastEvent = null;
  private lastEventSubscription: Subscription = null;
  constructor(
    public utils: Utils,
    private firebaseDatabase: FirebaseDatabase,
    private cargoLastEventService: CargoLastEventService,
    public global: Global,
    public snackbarService: SnackBarService,
    private dialog: MatDialog,
    public standardMapService: StandardMapService,
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.cargos && changes.cargos.currentValue) {
      if (this.cargosTemp === null) {
        this.cargosTemp = this.cargosTemp;
      } else {
        this.cargosTemp = this.cargos;
      }
    }
    if (changes && changes.cargoSelected && changes.cargoSelected.currentValue || this.cargoSelected === null) {
      if (this.cargoSelected === null) {
        this.cargosTemp = this.cargos;
        this.cargoSelectedIndex = null;
        this.onRealtimeCargo();
      } else {
        this.cargoSelectedIndex = this.cargoSelected.consecutive;
        this.showAMarker(changes);
      }
    }
  }


  showAMarker(changes: SimpleChanges) {
    this.cargosTemp = [changes.cargoSelected.currentValue];
    if (!this.cargoSelected.lastPointLocation && !this.cargoSelected.lastPointLocationGps) {
      this.showMessageNoLocation(this.cargoSelected);
      this.cargosTemp = this.cargos;
    }
    this.onRealtimeCargo();
  }

  showMessageNoLocation(cargo: Cargo) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: `La placa ${cargo.licensePlate} no tiene seguimientos registrados`,
      hideBtnConfirm: true,
      hideBtnCancel: true,
      iconError: true
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    this.dialog.open(DialogComponent, dialogConfig);
  }

  private pendingCargos = 0;

  onRealtimeCargo() {
    this.loading = true;
    this.loadingMap.emit(true);
    this.deleteAllObservables();
    const requestId = ++this.realtimeRequestId;
    this.listenLastGpsEvent(requestId);
    if (this.cargosTemp) {
      if (this.standardMapComponent) {
        this.standardMapComponent.removeAllMarkers();
      }
      this.tempLocationsCargos = {};
      this.tempLocationsCargo = {};
      this.cargoTrackingList = {};
      this.cargoAnomaliesList = {};
      this.lastPoints = {};
      this.countCargos = 1;
      if (this.cargosTemp.length) {
        if (this.isGlobalTrackingView()) {
          this.renderGlobalCargos(requestId);
          return;
        }
        this.pendingCargos = this.cargosTemp.length;
        this.cargosTemp.forEach((cargo: Cargo) => {
          this.getDataTracking(cargo, requestId);
        });
      } else {
        this.refreshRoute('route');
        this.loading = false;
        this.loadingMap.emit(false);
      }
    } else {
      this.loading = false;
      this.loadingMap.emit(false);
    }
  }

  /**
 * The global map uses the last positions returned by /cargo/tracking/map.
 * Firebase history and anomalies are only needed to show the route of a selected cargo.
 */
  private isGlobalTrackingView(): boolean {
    return !this.cargoSelected || this.cargosTemp.length !== 1
      || this.cargosTemp[0].consecutive !== this.cargoSelected.consecutive;
  }

  /**
   * Escucha el último evento GPS del servicio filtrado, para enriquecer el globo de su última
   * posición con el mismo detalle que muestra el seguimiento del servicio.
   *
   * Solo aplica con una placa seleccionada: en la vista de todas las placas esto abriría un
   * listener de Realtime Database por cada vehículo en ruta. La baja la hace
   * `deleteAllObservables()`, que ya corre al inicio de cada render y en `ngOnDestroy`.
   */
  private listenLastGpsEvent(requestId: number): void {
    if (!this.cargosTemp || !this.cargosTemp.length) return;
    if (this.isGlobalTrackingView()) return;
    if (!this.cargoSelected || !this.cargoSelected.id) return;

    this.lastEventSubscription = this.cargoLastEventService.listen(this.cargoSelected.id)
      .subscribe((event) => {
        // Mismo guard que el resto de los listeners: una emisión que llega después de cambiar
        // de placa no debe repintar el mapa de la placa nueva.
        if (requestId !== this.realtimeRequestId) return;
        this.lastGpsEvent = event;
        this.repaintSelectedRoute();
      });
  }

  /**
   * Rearma los globos del recorrido ya dibujado. `lastEvent` y `tracking` los escribe la misma
   * integración, así que el redibujado normal casi siempre ya trae el evento; esto cubre el
   * caso en que llega después y el globo quedaría sin el detalle.
   */
  private repaintSelectedRoute(): void {
    if (!this.cargoSelected || !this.polyline || !this.polyline.length) return;
    this.showAnomalies(lastTrackingPoint(this.polyline));
    this.refreshRoute('polyline');
  }

  private async renderGlobalCargos(requestId: number): Promise<void> {
    const cargos = [...this.cargosTemp];
    try {
      for (const cargo of cargos) {
        if (requestId !== this.realtimeRequestId) return;
        const lastPointLocation = cargo && (cargo.lastPointLocation || cargo.lastPointLocationGps);
        if (!lastPointLocation || !lastPointLocation.location
          || !lastPointLocation.location.lat || !lastPointLocation.location.lng) continue;

        const lastPoint = { ...lastPointLocation };
        lastPoint['lat'] = lastPointLocation.location.lat;
        lastPoint['lng'] = lastPointLocation.location.lng;
        lastPoint['key'] = cargo.consecutive + '_' + lastPointLocation.id;
        delete lastPoint['location'];
        await this.createLastPoint(lastPoint, cargo);
      }
      if (requestId !== this.realtimeRequestId) return;
      await this.refreshRoute('route');
    } catch (error) {
      console.error(error);
    } finally {
      if (requestId === this.realtimeRequestId) {
        this.loading = false;
        this.loadingMap.emit(false);
      }
    }
  }

  /**
 * This method brings the tracking history of the selected cargo from Firebase.
 */
  private getDataTracking(cargo: Cargo, requestId: number): void {
    this.referencesRealtimeCargos[cargo.consecutive] = this.firebaseDatabase.getRefDatabase(`cargo/${cargo.id}/tracking`);
    this.referencesRealtimeCargos[cargo.consecutive].on("value", async (response) => {
      if (requestId !== this.realtimeRequestId) return;
      try {
        const data = await this.firebaseDatabase.getDataTrackingSnapshot(response);
        if (requestId !== this.realtimeRequestId) return;
        this.cargoTrackingList[cargo.consecutive] = [...data.listLocations];
        this.getDataAnomalies(cargo, requestId);
      } catch (error) {
        console.error(error);
        this.completeCargoTrackingLoad(cargo, requestId);
      }
    }, (error) => {
      console.error(error);
      this.completeCargoTrackingLoad(cargo, requestId);
    })
  }

  /**
 * This method brings the anomalies of the load storage in a realtime collection of firebase according to the id of the load.
 */
  private getDataAnomalies(cargo: Cargo, requestId: number): void {
    const ref = this.firebaseDatabase.getRefDatabase(`cargo/${cargo.id}/anomalies`);
    ref.once('value')
      .then((data) => {
        if (requestId !== this.realtimeRequestId) {
          ref.off();
          return;
        }
        const cargoAnomalies = data.val();
        this.cargoAnomaliesList[cargo.consecutive] =
          !cargoAnomalies || !Object.keys(cargoAnomalies) || !Object.keys(cargoAnomalies).length
            ? []
            : Object.keys(cargoAnomalies).map(key => {
              return { ...cargoAnomalies[key], key };
            });
        ref.off();
        this.completeCargoTrackingLoad(cargo, requestId);
      }).catch((err) => {
        console.error(err);
        ref.off();
        this.completeCargoTrackingLoad(cargo, requestId);
      });
  }

  private completeCargoTrackingLoad(cargo: Cargo, requestId: number): void {
    if (requestId !== this.realtimeRequestId) return;
    if (!this.cargoTrackingList[cargo.consecutive]) this.cargoTrackingList[cargo.consecutive] = [];
    if (!this.cargoAnomaliesList[cargo.consecutive]) this.cargoAnomaliesList[cargo.consecutive] = [];
    this.updateMarkers(cargo);
    this.checkLoadingComplete();
  }

  private checkLoadingComplete(): void {
    this.pendingCargos--;
    if (this.pendingCargos <= 0) {
      this.loading = false;
      this.loadingMap.emit(false);
    }
  }

  async updateMarkers(cargo: Cargo) {
    const path = this.cargoTrackingList[cargo.consecutive];
    const lastPointLocation = cargo && (cargo.lastPointLocation || cargo.lastPointLocationGps);
    if (this.tempLocationsCargos[cargo.consecutive]) {
      if (path.length && path.length > 1) {
        this.standardMapComponent.removeMarker(path[path.length - 2].key);
      } else if (lastPointLocation) {
        this.standardMapComponent.removeMarker(cargo.consecutive + '_' + lastPointLocation.id);
      }
    }
    if (path.length) {
      if (this.cargosTemp.length === 1) {
        if (this.cargoSelected && this.cargoSelected.consecutive === cargo.consecutive) {
          this.polyline = [];
          const polylineToSend = path.map(trackingLocation => {
            const index = this.cargoAnomaliesList[cargo.consecutive] ?
              this.cargoAnomaliesList[cargo.consecutive].findIndex(anomaly => {
                return !!(anomaly.latLng && anomaly.latLng.lat === trackingLocation.lat && anomaly.latLng.lng === trackingLocation.lng &&
                  anomaly.fingerprint && trackingLocation.fingerprint
                  && anomaly.fingerprint.date === trackingLocation.fingerprint.date)
              }) : -1;
            if (index !== -1) {
              if (this.cargoAnomaliesList[cargo.consecutive][index].name)
                trackingLocation['name'] = this.cargoAnomaliesList[cargo.consecutive][index].name;
              else if (this.cargoAnomaliesList[cargo.consecutive][index].anomaly)
                trackingLocation['anomaly'] = this.cargoAnomaliesList[cargo.consecutive][index].anomaly;
            }
            return trackingLocation;
          }).filter(location => location.lat && location.lng);
          this.polyline = polylineToSend;
          this.setInfoEnd();
          await this.createPoint(this.polyline, cargo);
          this.showAnomalies(lastTrackingPoint(this.polyline));
          this.refreshRoute('polyline');
        }
      }
      if (this.cargosTemp.length > 1) {
        await this.createLastPoint(path[path.length - 1], cargo);
      }
    } else if (lastPointLocation && lastPointLocation.location &&
      lastPointLocation.location.lat && lastPointLocation.location.lng) {
      let lastPoint = { ...lastPointLocation };
      lastPoint['lat'] = lastPointLocation.location.lat;
      lastPoint['lng'] = lastPointLocation.location.lng;
      lastPoint['key'] = cargo.consecutive + '_' + lastPointLocation.id;
      delete lastPoint['location'];

      await this.createLastPoint(lastPoint, cargo);
    }
    if (this.countCargos === this.cargosTemp.length) {
      if (this.cargosTemp.length > 1 || path.length == 0) {
        this.refreshRoute('route')
      }
    }
    if (this.countCargos !== this.cargosTemp.length) {
      this.countCargos++;
    }
    if (this.cargoSelected && this.cargoSelected.consecutive === cargo.consecutive && this.lastPoints[cargo.consecutive]) {
      this.standardMapComponent.setCenterMap(this.lastPoints[cargo.consecutive].lat, this.lastPoints[cargo.consecutive].lng, 16);
    }
  }

  async createLastPoint(lastPoint, cargo) {
    this.lastPoints[cargo.consecutive] = lastPoint;
    this.lastPoints[cargo.consecutive]['contentInfoWindow'] = await this.createContentInfoWindow(this.lastPoints[cargo.consecutive], cargo);
    this.lastPoints[cargo.consecutive]['icon'] = this.utils.isSatelliteLockService(cargo)
      ? this.global.pathMarkerSatelliteLock
      : this.global.pathMarkerVehicle;
    this.lastPoints[cargo.consecutive]['showMarker'] = true;
    this.tempLocationsCargos[cargo.consecutive] = { path: [this.lastPoints[cargo.consecutive]], showPolyline: true, showRouteGoogle: false };
  }


  async createPoint(array, cargo) {
    for (const item of array) {
      this.lastPoints[item.position] = item;
      this.lastPoints[item.position]['contentInfoWindow'] = await this.createContentInfoWindow(this.lastPoints[item.position], cargo);
      this.lastPoints[item.position]['showMarker'] = !!(item.fingerprint && item.fingerprint.userId !== "SATRACK" && (item.anomaly || item.name));
      this.tempLocationsCargo[item.position || item.key] = { path: [this.lastPoints[item.position]], showPolyline: true, showRouteGoogle: true };
    }
  }

  /**
   * @param lastPoint el punto que el vehículo reportó de último, identificado por referencia.
   * Antes se deducía como `length - 2`, dando por hecho que el marcador de destino cerraba
   * siempre el arreglo; en los servicios que no lo traen, el trato de "último punto" le caía
   * al anterior.
   */
  showAnomalies(lastPoint: any) {
    if (this.polyline && this.polyline.length) {
      this.polyline.forEach(async (polyline) => {
        if (polyline) {
          const isLastElement = !!lastPoint && polyline === lastPoint;
          // El último punto entra siempre: su marcador ya se muestra sí o sí unas líneas más
          // abajo, así que sin esto se quedaba con el globo genérico de createPoint() cuando
          // el reporte no traía novedad asociada.
          if (isLastElement
            || (polyline.hasOwnProperty('name') && polyline['name'] !== 'Reiniciando ruta')
            || (polyline.hasOwnProperty('anomaly') && polyline['anomaly'] !== 'Reiniciando ruta')) {
            this.setMarkerProperties(polyline, isLastElement);
            polyline['showMarker'] = true;
          }
          if (isLastElement) {
            polyline['showMarker'] = true;
            polyline['setCenter'] = true;
            polyline['zoom'] = 16;
          }
        }
      })
    }
  }
  async setMarkerProperties(polyline, lastItem: boolean) {
    if (!lastItem) {
      let iconName = polyline.hasOwnProperty('name') && polyline.name ? polyline['name'] : polyline.hasOwnProperty('anomaly') ? polyline['anomaly'] : null;
      polyline['icon'] = iconName ? this.standardMapService.getIcon(iconName) : this.global.pathMarkerVehicleNoLastLocations;
      polyline['icon'] = polyline['icon'] ? polyline['icon'] : this.global.pathMarkerVehicleNoLastLocations;
    }
    polyline['contentInfoWindow'] = await this.createContentInfoPolylineWindow(polyline, lastItem);
  }

  async refreshRoute(key): Promise<void> {
    this.locationsCargos = {};
    return new Promise((resolve, reject) => {
      try {
        if (key === 'polyline') {
          // El marcador de destino no es parte del recorrido, así que no entra en la línea.
          // Se filtra por llave en vez de recortar el final a ciegas: ese `pop()` se comía un
          // punto GPS real cuando el servicio no traía destino, y además mutaba this.polyline,
          // que el repintado del último evento vuelve a recorrer.
          const path = trackingPathOnly(this.polyline);
          this.locationsCargos[this.cargoSelected.id] = { path, showPolyline: true, showRouteGoogle: true };
          this.mapOptions['route'] = this.tempLocationsCargo;
          this.mapOptions[key] = this.locationsCargos;
          this.mapOptions = { ...this.mapOptions };
        } else if (key === 'route') {
          this.locationsCargos = this.tempLocationsCargos;
          this.mapOptions['polyline'] = [];
          this.mapOptions[key] = this.locationsCargos;
          this.mapOptions = { ...this.mapOptions };
        }
        this.mapOptions['removeAllPolylines'] = true;
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  }

  private createCargoPath(resp: any) {
    let path = [];
    const arrayRoute = this.utils.snapshotToArray(resp);
    if (arrayRoute.length) {
      path = arrayRoute.sort(
        (objA, objB) => Number(objA.date) - Number(objB.date),
      );
    }
    return path;
  }

  private createContentInfoWindow(lastPoint: any, cargo: Cargo) {
    if (!lastPoint || !lastPoint.fingerprint) {
      return buildMapInfoWindow({
        icon: 'fas fa-truck',
        title: cargo.licensePlate ? cargo.licensePlate : 'Vehículo',
        subtitle: cargo.consecutive ? `Servicio ${cargo.consecutive}` : '',
        chips: [{ text: 'Sin reporte', tone: 'warning' }]
      });
    }

    const rawDate = lastPoint.fingerprint.date;
    const formattedDate = rawDate && typeof rawDate === 'object'
      ? (rawDate.time ? DateManager.formatDate(rawDate.time) : '')
      : rawDate;

    return buildMapInfoWindow({
      icon: 'fas fa-truck',
      title: cargo.licensePlate ? cargo.licensePlate : 'Vehículo',
      subtitle: formattedDate ? formattedDate.slice(0, 16) : '',
      rows: [
        { label: 'Usuario', value: lastPoint.fingerprint.userName },
        { label: 'Anomalía', value: lastPoint.anomaly },
        {
          label: 'Último seguimiento',
          value: cargo.lastPointLocation ? cargo.lastPointLocation.name : ''
        },
        { label: 'Registro', value: lastPoint.fromWeb ? 'Web' : 'Conductor' },
        {
          label: 'Posición',
          value: this.utils.isDefined(lastPoint.lat) && this.utils.isDefined(lastPoint.lng)
            ? lastPoint.lat + ', ' + lastPoint.lng : ''
        }
      ],
      // La observación de la integración repite el estado que ya sale en las filas de
      // arriba ('Anomalía' o 'Último seguimiento'), así que ese pedazo se descuenta.
      footer: lastPoint.observation
        ? stripVehicleStateObservation(lastPoint.observation, lastPoint.anomaly)
        : (cargo.lastPointLocation
          ? stripVehicleStateObservation(cargo.lastPointLocation.observation, cargo.lastPointLocation.name)
          : '')
    });
  }

  /**
   * @param isLastPoint marca la última posición reportada. Solo ese globo lleva el detalle del
   * último evento GPS: es el único punto del que ese dato es cierto ahora mismo, y el nodo
   * `lastEvent` guarda un solo evento por servicio, no el histórico de cada punto.
   */
  private createContentInfoPolylineWindow(polyline, isLastPoint: boolean = false) {
    const anomalyName = polyline && polyline.name ? polyline.name : polyline.anomaly;
    // El estado que el globo ya muestra por su cuenta: el chip en el último punto, el título
    // en los demás. Es lo único que se descuenta de la observación de la integración.
    const shownVehicleState = isLastPoint && this.lastGpsEvent && this.lastGpsEvent.vehicleStatus
      ? this.lastGpsEvent.vehicleStatus
      : anomalyName;

    return buildMapInfoWindow({
      icon: isLastPoint ? 'fas fa-truck' : 'fas fa-exclamation-circle',
      title: anomalyName ? anomalyName : (isLastPoint ? 'Última posición' : 'Novedad'),
      subtitle: polyline.fingerprint && polyline.fingerprint.date
        ? polyline.fingerprint.date.slice(0, 16) : '',
      chips: isLastPoint ? this.cargoLastEventService.getStatusChips(this.lastGpsEvent) : [],
      rows: [
        {
          label: 'Responsable',
          value: polyline.fingerprint && polyline.fingerprint.userName
            ? polyline.fingerprint.userName : ''
        },
        { label: 'Registro', value: polyline.fromWeb ? 'Web' : 'Conductor' }
      ],
      sections: isLastPoint ? this.cargoLastEventService.getDetailSections(this.lastGpsEvent) : [],
      footer: stripVehicleStateObservation(polyline.observation, shownVehicleState)
    });
  }

  deleteAllObservables() {
    Object.keys(this.referencesRealtimeCargos).forEach((key) => {
      if (this.referencesRealtimeCargos[key]) this.referencesRealtimeCargos[key].off();
    });
    this.referencesRealtimeCargos = {};
    if (this.lastEventSubscription) {
      this.lastEventSubscription.unsubscribe();
      this.lastEventSubscription = null;
    }
    // El evento es de la placa que se está dejando: no debe sobrevivir al cambio.
    this.lastGpsEvent = null;
  }

  ngOnDestroy() {
    this.deleteAllObservables();
  }

  setInfoEnd() {
    if (!this.cargoSelected) return '';
    const addresses = [];
    this.cargoSelected.cargoFeature.uploadDownload.origin.addresses.forEach((address) => {
      addresses.push(address);
    });
    for (const destination of this.cargoSelected.cargoFeature.uploadDownload.destination) {
      destination.addresses.forEach((address) => {
        addresses.push(address);
      });
    }
    if (addresses.length > 1) {
      let end = addresses[addresses.length - 1];
      if (end) {
        this.polyline.push({
          key: 'destinationMarker',
          icon: this.global.pathMarkerDestination,
          lat: end.location && end.location.lat ? end.location.lat : null,
          lng: end.location && end.location.lng ? end.location.lng : null,
          contentInfoWindow: buildMapInfoWindow({
            icon: 'fas fa-map-marker-alt',
            title: end.address ? end.address : 'Destino',
            subtitle: 'Destino',
            rows: [
              {
                label: 'Fin',
                value: end.durationTime && end.durationTime.endDate
                  ? end.durationTime.endDate.slice(0, 16) : ''
              }
            ]
          }),
          showMarker: true
        });
      }
    }
  }

}
